import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"
import Config from "../../Config.jsx";

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  IconButton,
  Card,
  CardContent,
  ListItemSecondaryAction,
  Tooltip,
  ListItemAvatar,
  Avatar,
  Badge,
  styled,
} from '@material-ui/core';

import {
  grey,
} from '@material-ui/core/colors'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

class StageListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      selectedStageID: -1,
      targetStageId: -1,
    };
    autoBind(this);

    this.refresh();
  }

  refresh() {
    let requestObj = {
      locale_id: this.props.parent.props.localeData['id'],
    };
    this.props.root.refs.API.request("get_stage_list_by_locale_id", requestObj, this.getStageListOK, this.getStageListFailed);
  }

  getStageListOK(res) {
    this.props.parent.setState({
      stageList: res.body['result'],
    });

    if (this.state.selectedStageID < 0 && res.body['result'].length > 0) {
        this.props.parent.refresh(res.body['result'][0]['id']);
    }
    else {
      this.props.parent.refreshOK();
    }
  }

  getStageListFailed(err) {
    console.log("get stage list failed");
  }

  handleStageClicked(index, stage_id) {
    this.selectStage(stage_id);
    this.props.parent.selectStageById(stage_id);
  }

  selectStage(stage_id) {
    this.setState({
      selectedStageID: stage_id,
    });
    this.state.selectedStageID = stage_id;
  }

  onDragEnd(result) {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const newStageList = Array.from(this.props.parent.state.stageList);
    const [reorderedItem] = newStageList.splice(source.index, 1);
    newStageList.splice(destination.index, 0, reorderedItem);

    this.props.parent.setState({
      stageList: newStageList,
    });

    const stageIds = newStageList.map(stage => stage.id);
    this.reorderStages(stageIds);
  }

  reorderStages(stageIds) {
    let requestObj = {
      locale_id: this.props.parent.props.localeData['id'],
      stage_ids: stageIds,
    };
    // Note to developer: "reorder_stages" is a new proposed API endpoint.
    // The backend needs to implement this endpoint to update the display order of stages for a given locale.
    this.props.root.refs.API.request("reorder_stages", requestObj, this.reorderStagesOK, this.reorderStagesFailed);
  }

  reorderStagesOK(res) {
    // No notification on success
    this.refresh();
  }

  reorderStagesFailed(err) {
    this.props.root.addNotification("error updating stage order", 'error');
    // Revert optimistic update on failure
    this.refresh();
  }

  deleteStageClicked(id) {
    this.setState({
      targetStageId: id,
    });
    this.state.targetStageId = id;

    let dialogText = {
      title: Localization.strings.DELETE_STAGE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteStageConfirmClicked, this.deleteStageCancelClicked);
  }

  deleteStageConfirmClicked() {
    let requestObj = {
      stage_id: this.state.targetStageId,
    };
    this.props.root.refs.API.request("delete_stage", requestObj, this.deleteStageOK, this.deleteStageFailed);
  }

  deleteStageCancelClicked() {

  }

  deleteStageOK(res) {
    this.props.root.addNotification(Localization.strings.DELETED);
    if (this.state.targetStageId == this.props.parent.refs.stageDetailView.state.stageData['id']) {
      this.setState({ selectedStageID: -1 });
      this.state.selectedStageID = -1;
      this.props.parent.selectStageById(-1);
    }
    this.refresh();
  }

  deleteStageFailed(err) {
    console.log("delete stage failed");
  }

  render() {
    let stageList = this.props.parent.state.stageList;

    const SmallAvatar = styled(Avatar)(({ theme }) => ({
      width: 16,
      height: 16,
      right: -32,
      top: 32,
      border: `2px solid grey`,
    }));

    return (
      <div style={{maxHeight:this.props.parent.state.maxHeight, overflow:'auto'}}>
        <If condition={stageList.length > 0}>
          <Then>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="stages">
                {(provided, snapshot) => (
                  <List style={{padding:"0"}} ref={provided.innerRef} {...provided.droppableProps}>
                    {stageList.map( (row, i) => {
                      // console.log(row);
                      let iconString = "";
                      if (row['kind'] == 0) {
                        iconString = "movie";
                      }
                      else if (row['kind'] == 1) {
                        iconString = "photo";
                      }

                      let tn_path = '';
                      if(row['movie_list'].length > 0){
                        tn_path = row['movie_list'][0].tn_path;
                      }

                      return (
                        <Draggable key={row['id']} draggableId={String(row['id'])} index={i}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Card variant="outlined" className="margin-std padding-sm" >
                                <CardContent className="padding-zero">
                                  <ListItem
                                    button
                                    key={row['id']}
                                    onClick={() => this.handleStageClicked(i, row['id'])}
                                    selected={row['id'] == this.state.selectedStageID}
                                  >
                                    {/* add thumbnail here */}
                                    <If condition={tn_path != ''}>
                                      <Then>
                                        {/* <img
                                          style={{maxHeight:"10%", maxWidth:"20%", display:"block", marginRight:"20px", borderRadius:4}}
                                          src={Config.BASE_PATH() + tn_path}
                                        /> */}
                                        {/* <ListItemAvatar> */}
                                          {/* <Avatar variant="rounded" alt={row['stage_name']} src={Config.BASE_PATH() + tn_path} /> */}
                                          <Badge
                                            style={{marginRight:"20px"}}
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                            badgeContent={
                                              <SmallAvatar variant="rounded">
                                                <Icon>{iconString}</Icon>
                                              </SmallAvatar>
                                            }
                                          >
                                            <Avatar style={{height: '50px', width: '50px'}} variant="rounded" alt={row['stage_name']} src={Config.BASE_PATH() + tn_path} />
                                          </Badge>
                                      </Then>
                                      <Else>
                                      <Badge
                                            style={{marginRight:"20px"}}
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                            badgeContent={
                                              <SmallAvatar variant="rounded">
                                                <Icon>{iconString}</Icon>
                                              </SmallAvatar>
                                            }
                                          >
                                            <Avatar style={{height: '50px', width: '50px'}} variant="rounded">
                                              <Icon>{iconString}</Icon>
                                            </Avatar>
                                          </Badge>
                                      </Else>
                                    </If>
                                    {/* <ListItemIcon><Icon>{iconString}</Icon></ListItemIcon> */}
                                    <ListItemText>{row['stage_name']}</ListItemText>
                                    <ListItemSecondaryAction>
                                      <Tooltip title={Localization.strings.DELETE}>
                                        <IconButton
                                          onClick={()=>this.deleteStageClicked(row['id'])}
                                        >
                                          <Icon style={{ color: grey[700] }}>delete</Icon>
                                        </IconButton>
                                      </Tooltip>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                </CardContent>
                              </Card>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </List>
                )}
              </Droppable>
            </DragDropContext>
          </Then>
          <Else>
            <Card style={{margin: "10px"}}>
              <CardContent>
                No stage has been created yet. Click + NEW STAGE to create at least one in your VITALS.
              </CardContent>
            </Card>
          </Else>
        </If>
      </div>
    )
  }
}

export default StageListView;
